// ═══════════════════════════════════════════════════════════════════════════════
// Auth screens — shared shell (language switcher + card)
// ═══════════════════════════════════════════════════════════════════════════════

import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';
import { APP_ICONS } from '../../lib/iconAssets';
import { PLAY_BANNER_OFFSET_PADDING_CLASS } from '../../lib/layoutChrome';

type AuthLayoutProps = {
  children: ReactNode;
  footer?: ReactNode;
  /** Wider card for flows that include PICS / long forms */
  contentMaxWidthClassName?: string;
  backTo?: string;
  onBackClick?: () => void;
};

export const AuthLayout = ({
  children,
  footer,
  contentMaxWidthClassName = 'max-w-md',
  backTo,
  onBackClick,
}: AuthLayoutProps) => (
  <div className={`flex min-h-screen flex-col bg-gray-50 px-4 py-3 sm:py-4 ${PLAY_BANNER_OFFSET_PADDING_CLASS}`}>
    <div className={`mx-auto flex w-full items-center justify-between ${contentMaxWidthClassName}`}>
      {onBackClick ? (
        <button
          type="button"
          onClick={onBackClick}
          className="inline-flex h-10 min-w-10 items-center justify-center rounded-lg border border-gray-200 bg-white px-3 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
          aria-label="Back"
        >
          &lt;
        </button>
      ) : backTo ? (
        <Link
          to={backTo}
          className="inline-flex h-10 min-w-10 items-center justify-center rounded-lg border border-gray-200 bg-white px-3 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
          aria-label="Back"
        >
          &lt;
        </Link>
      ) : (
        <span />
      )}
      <LanguageSwitcher />
    </div>

    <div className="flex flex-col items-center pt-2 md:pt-2">
      <img src={APP_ICONS.menu} alt="MaidEasy logo" className="mb-4 h-16 w-16 rounded-xl object-contain" />
      <div
        className={`w-full rounded-2xl bg-white p-6 shadow-lg sm:p-8 ${contentMaxWidthClassName}`}
      >
        {children}
      </div>
      {footer ? (
        <div
          className={`mt-6 w-full text-center text-sm text-gray-600 ${contentMaxWidthClassName}`}
        >
          {footer}
        </div>
      ) : null}
    </div>
  </div>
);
